import $ from 'jquery';
import 'webpack-jsqrcode/dist/jsqrcode.js';

function init_qrcode_reader() {
  function showQRIntro() {
    confirm("Use your camera to take a picture of a QR code.");
  }
  
  function openQRCamera(element, target) {
    var reader = new FileReader();
    reader.onload = function() {
      element.value = "";
      qrcode.callback = function(res) {
        if(res instanceof Error) {
          alert("No QR code found. Please make sure the QR code is within the camera's frame and try again.");
        } else {
          element.parent().prev().val(res); //find('.qrcode-text').value = res;
        }
      };
      qrcode.decode(reader.result);
    };
    reader.readAsDataURL(target.files[0]);
  }
  
  $('.qrcode-text-btn').on('click', 'input', function(event) {
    showQRIntro();
  });
  
  $('.qrcode-text-btn').on('change', 'input', function(event) {
    openQRCamera($(this), event.target);
  });
}

export default init_qrcode_reader;
